import { FileText } from 'lucide-react';

/** Stands in for a photo thumbnail when the receipt is a PDF. */
export function ReceiptPdfTile() {
  return (
    <span
      data-testid="receipt-pdf-tile"
      className="flex h-full w-full flex-col items-center justify-center gap-0.5 bg-gray-100 dark:bg-gray-800"
    >
      <FileText
        aria-hidden="true"
        className="h-[45%] w-[45%] text-gray-500 dark:text-gray-400"
      />
      <span className="rounded bg-gray-700 px-1 text-xs font-semibold leading-tight text-white dark:bg-gray-200 dark:text-gray-900">
        PDF
      </span>
    </span>
  );
}
